import React from 'react';
import { Container, Card, Row, Col, Badge, Alert } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

function Holidays() {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  const holidays = [
    { date: '1 stycznia', name: 'Nowy Rok', icon: '🎉' },
    { date: '6 stycznia', name: 'Święto Trzech Króli', icon: '👑' },
    { date: 'Niedziela', name: 'Pierwszy dzień Wielkanocy', icon: '🐰', movable: true },
    { date: 'Poniedziałek', name: 'Drugi dzień Wielkanocy', icon: '🥚', movable: true },
    { date: '1 maja', name: 'Święto Pracy', icon: '⚒️' },
    { date: '3 maja', name: 'Święto Narodowe Trzeciego Maja', icon: '🇵🇱' },
    { date: 'Niedziela', name: 'Zielone Świątki (Zesłanie Ducha Świętego)', icon: '🕊️', movable: true },
    { date: 'Czwartek', name: 'Dzień Bożego Ciała', icon: '✝️', movable: true },
    { date: '15 sierpnia', name: 'Wniebowzięcie Najświętszej Maryi Panny', icon: '🙏' },
    { date: '1 listopada', name: 'Święto Wszystkich Świętych', icon: '🕯️' },
    { date: '11 listopada', name: 'Narodowe Święto Niepodległości', icon: '🎖️' },
    { date: '24 grudnia', name: 'Wigilia Bożego Narodzenia', icon: '🕯️' },
    { date: '25 grudnia', name: 'Pierwszy dzień Bożego Narodzenia', icon: '🎄' },
    { date: '26 grudnia', name: 'Drugi dzień Bożego Narodzenia', icon: '🎁' }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '2rem',
      paddingBottom: '4rem',
      width: '100%'
    }}>
      <Container>
        {/* HEADER */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-5"
        >
          <h1 className="text-white fw-bold mb-3">
            Dni ustawowo wolne od pracy
          </h1>
          <p className="text-white-50" style={{ fontSize: '1.2rem' }}>
            W Polsce mamy 14 świąt wolnych od pracy
          </p>
        </motion.div>

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            {/* WAŻNA INFORMACJA */}
            <motion.div {...fadeInUp} className="mb-5">
              <Alert 
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, rgba(245, 87, 108, 0.2) 0%, rgba(240, 147, 251, 0.2) 100%)',
                  border: '3px solid #f5576c'
                }}
              >
                <div className="text-center">
                  <FaExclamationTriangle size={50} className="mb-3" style={{ color: '#f5576c' }} />
                  <h4 className="fw-bold mb-3 text-white">
                    PAMIĘTAJ - Święto w sobotę!
                  </h4>
                  <div className="p-4" style={{ background: 'rgba(255,255,255,0.1)', borderRadius: '15px' }}>
                    <p className="text-white mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                      <strong>Zgodnie z art. 130 § 2 Kodeksu Pracy</strong> każdy dzień ustawowo wolny od pracy, 
                      który przypada w <strong>sobotę</strong> (tylko w sobotę, niedziela się tu nie liczy) 
                      skutkuje tym, że pracodawca powinien <strong>oddać Ci ten dzień w innym dniu</strong> 
                      okresu rozliczeniowego lub innym dniu roku!
                    </p>
                  </div>
                </div>
              </Alert>
            </motion.div>

            {/* LICZNIK ŚWIĄT */}
            <motion.div {...fadeInUp} transition={{ delay: 0.1 }} className="mb-5">
              <Card
                className="border-0 shadow-lg text-center"
                style={{
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, rgba(67, 233, 123, 0.2) 0%, rgba(56, 249, 215, 0.2) 100%)',
                  border: '2px solid #43e97b'
                }}
              >
                <Card.Body className="p-5">
                  <div style={{ fontSize: '4rem', fontWeight: 'bold', color: '#43e97b' }}>
                    14
                  </div>
                  <h4 className="text-white fw-bold">Dni wolnych od pracy</h4>
                </Card.Body>
              </Card>
            </motion.div>

            {/* LISTA ŚWIĄT */}
            <motion.div {...fadeInUp} transition={{ delay: 0.2 }}>
              <Card 
                className="border-0 shadow-lg"
                style={{ borderRadius: '20px', overflow: 'hidden' }}
              >
                <Card.Header
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none',
                    padding: '1.5rem'
                  }}
                >
                  <h4 className="text-white mb-0 fw-bold">
                    Lista wszystkich świąt
                  </h4>
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="g-3">
                    {holidays.map((holiday, index) => (
                      <Col key={index} xs={12} md={6}>
                        <motion.div
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: index * 0.05 }}
                        >
                          <Card
                            className="border-0 h-100"
                            style={{
                              borderRadius: '15px',
                              background: 'rgba(102, 126, 234, 0.05)',
                              transition: 'all 0.3s ease'
                            }}
                          >
                            <Card.Body className="p-3">
                              <div className="d-flex align-items-start">
                                <div 
                                  className="me-3"
                                  style={{ 
                                    fontSize: '2rem',
                                    flexShrink: 0
                                  }}
                                >
                                  {holiday.icon}
                                </div>
                                <div className="flex-grow-1">
                                  <div className="d-flex align-items-center mb-2">
                                    <Badge 
                                      bg={holiday.movable ? 'warning' : 'primary'}
                                      className="me-2"
                                      style={{ fontSize: '0.75rem' }}
                                    >
                                      {holiday.date}
                                    </Badge>
                                    {holiday.movable && (
                                      <Badge 
                                        bg="light"
                                        text="dark"
                                        style={{ fontSize: '0.7rem' }}
                                      >
                                        Ruchome
                                      </Badge>
                                    )}
                                  </div>
                                  <h6 className="mb-0 fw-bold">
                                    {holiday.name}
                                  </h6>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </motion.div>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
            </motion.div>

            {/* INFO BOX - ŚWIĘTA RUCHOME */}
            <motion.div {...fadeInUp} transition={{ delay: 0.3 }} className="mt-4">
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '20px',
                  background: 'rgba(255,255,255,0.05)',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <Card.Body className="p-4">
                  <div className="d-flex align-items-start">
                    <FaInfoCircle size={30} className="me-3 flex-shrink-0 text-info" />
                    <div>
                      <h6 className="text-white fw-bold mb-2">
                        Co to są święta ruchome?
                      </h6>
                      <p className="text-white-50 mb-0">
                        Święta ruchome to dni wolne, które <strong>nie mają stałej daty</strong> w kalendarzu. 
                        Ich termin zmienia się co roku i zależy od daty Wielkanocy. Do takich świąt należą: 
                        Wielkanoc, Zielone Świątki oraz Boże Ciało.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </motion.div>

            {/* DODATKOWE INFO - PRACA W ŚWIĘTO */}
            <motion.div {...fadeInUp} transition={{ delay: 0.4 }} className="mt-4">
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, rgba(79, 172, 254, 0.1) 0%, rgba(0, 242, 254, 0.1) 100%)',
                  border: '2px solid #4facfe'
                }}
              >
                <Card.Body className="p-4">
                  <h5 className="text-white fw-bold mb-3">
                    💡 Czy młodociany może pracować w święto?
                  </h5>
                  <div className="p-3" style={{ background: 'rgba(255,255,255,0.1)', borderRadius: '10px' }}>
                    <p className="text-white mb-2">
                      <strong>Nie!</strong> Młodociany <strong>nie może być zatrudniony w dni ustawowo wolne od pracy</strong>, 
                      w tym w święta.
                    </p>
                    <p className="text-white mb-0">
                      Zgodnie z Kodeksem Pracy, młodociany ma prawo do odpoczynku w te dni, 
                      bez względu na rodzaj wykonywanej pracy czy potrzeby pracodawcy.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Holidays;